import _ from "lodash";

export const compareArrays = (initialList, finalList) => {
    const initialValuesMap = new Map<string, any>();
    const finalValuesMap = new Map<string, any>();

    const stringifiesValuesAndKeys = (value: any) => {
        return JSON.stringify(value, Object.keys(value).sort());
    };

    initialList.forEach(value => initialValuesMap.set(stringifiesValuesAndKeys(value), value));

    finalList.forEach(value => finalValuesMap.set(stringifiesValuesAndKeys(value), value));

    const modifiedValues = initialList
        .map(valueInInitial => {
            const objectKey = stringifiesValuesAndKeys(valueInInitial);
            const valueInFinalValueMap = finalValuesMap?.get(objectKey);

            if (
                finalValuesMap?.has(objectKey) &&
                stringifiesValuesAndKeys(valueInFinalValueMap) !==
                    stringifiesValuesAndKeys(valueInInitial)
            ) {
                return valueInFinalValueMap;
            }
        })
        .filter(Boolean);

    const createdValues = finalList
        .map(valueInFinalvalue => {
            const objectKey = stringifiesValuesAndKeys(valueInFinalvalue);

            if (!initialValuesMap.has(objectKey)) {
                return valueInFinalvalue;
            }
        })
        .filter(Boolean);

    const deletedValues = initialList
        .map(valuesInInital => {
            const objectKey = stringifiesValuesAndKeys(valuesInInital);

            if (!finalValuesMap.has(objectKey)) {
                return valuesInInital;
            }
        })
        .filter(Boolean);

    return { modifiedValues, createdValues, deletedValues };
};

export const omitKeysFromArray = (listOfObjects, keyList) => {
    return listOfObjects.map(value => _.omit(value, [...keyList]));
};
